import React, { useContext, useEffect, useState } from "react";

import LazyLoading from "../../components/LazyLoading";
import { Col, Form, Modal, Row } from "@themesberg/react-bootstrap";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import { BASE_URL } from "../../config";
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "react-data-table-component-extensions/dist/index.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DashboardDetails = ({ showModal, setShowModal, id, setId, fetchData }) => {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN);

  useEffect(() => {
    if (showModal) {
      fetchWrapper()
        .doPost({
          url: "/api/v1/dashboard_detail",
          body: { id: id },
          onSuccess: async (response) => {
            setData(response.data.data);
            setFilterData([])
          },
          onError: (response) => {
            alert(response.data.message);
          },
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [showModal]);

  const handleFilter = () => {
    if (!startDate || !endDate) {
      Swal.fire("Error", "Selecciona un rango de fechas válido.", "error");
      return;
    }

    fetchWrapper()
      .doPost({
        url: "/api/v1/dashboard_filter",
        body: {
          id: id,
          start_date: startDate.toISOString().split("T")[0], // Formato: YYYY-MM-DD
          end_date: endDate.toISOString().split("T")[0],
        },
        onSuccess: async (response) => {
          setFilterData(response.data.data);
        },
        onError: (response) => {
          Swal.fire("Error", response.data.message, "error");
        },
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleClose = () => {
    setShowModal(false);
    setId(null);
  };



  const columnsUser = [
    {
      name: "Últimos 7 días",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.this_week)}</>,
    },
    {
      name: "Últimos 15 días",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.two_week)}</>,
    },
    {
      name: "Últimos 30 días",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.this_month)}</>,
    },
  ];

  const columnSales = [
    {
      name: "Total",
      cell: (row) => <>${new Intl.NumberFormat("de-DE").format(row.total)}</>,
    },
    {
      name: "Total Seifrei",
      cell: (row) => <>${new Intl.NumberFormat("de-DE").format(row.seifrei_total)}</>,
    },
    {
      name: "Total Cleaner",
      cell: (row) => <>${new Intl.NumberFormat("de-DE").format(row.cleaner_total)}</>,
    },
  ];

  const columnItem = [
    {
      name: "Ordenes",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.ordenes)}</>,
    },
    {
      name: "Bolsa S",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.small_bag)}</>,
    },
    {
      name: "Bolsa M",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.medium_bag)}</>,
    },
    {
      name: "Lavado",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.lavado)}</>,
    },
    {
      name: "Planchado",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.planchado)}</>,
    },
    {
      name: "Combo",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.combo)}</>,
    },
  ];
  const columnFilter = [
    {
      name: "Total",
      cell: (row) => <>${new Intl.NumberFormat("de-DE").format(row.total)}</>,
    },
    {
      name: "Total Seifrei",
      cell: (row) => <>${new Intl.NumberFormat("de-DE").format(row.seifrei_total)}</>,
    },
    {
      name: "Total Cleaner",
      cell: (row) => <>${new Intl.NumberFormat("de-DE").format(row.cleaner_total)}</>,
    },
    {
      name: "Ordenes",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.ordenes)}</>,
    },
    {
      name: "Bolsa S",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.small_bag)}</>,
    },
    {
      name: "Bolsa M",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.medium_bag)}</>,
    },
    {
      name: "Lavado",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.lavado)}</>,
    },
    {
      name: "Planchado",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.planchado)}</>,
    },
    {
      name: "Combo",
      cell: (row) => <>{new Intl.NumberFormat("de-DE").format(row.combo)}</>,
    },
  ];

  return (
    <Modal
      show={showModal}
      onHide={() => handleClose()}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Detalles de la Región
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <h4>Número de usuarios activos:</h4>
        </div>
        <DataTable columns={columnsUser} data={data} />
        <div className="row mt-5">
          <h4>Pedidos del último mes:</h4>
          <DataTable columns={columnItem} data={data} />
        </div>
        <div className="row mt-5">
          <h4>Ventas del último mes:</h4>
          <DataTable columns={columnSales} data={data} />
        </div>
        <div className="mt-5">
          <h4>Filtrar por rango de fechas:</h4>
          <Row className="align-items-center">
            <Col md={4}>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Fecha de inicio"
                className="form-control"
              />
            </Col>
            <Col md={4}>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                placeholderText="Fecha de fin"
                className="form-control"
              />
            </Col>
            <Col md={4}>
              <button className="btn btn-primary" onClick={handleFilter}>
                Filtrar
              </button>
            </Col>
          </Row>
          <div className="mt-4">
            <h5>Resultados filtrados:</h5>
            <DataTable columns={columnFilter} data={filterData} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-light" onClick={() => handleClose()}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DashboardDetails;
